import { gql } from "apollo-boost"

export const getEquipmentAttachmentById = gql`
  query getEquipmentAttachmentByID($id: ID!) {
    EquipmentAttachmentByID(id:$id) {
      id    
      description
      isBlocked
      concept {
        id
        name
      }
      documents {
        id,
        name,
        type,
        url
      }
    }
  }
`